    import React from 'react';

    const statesInIndia = [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
    'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
    'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
    'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
    'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
    'Uttar Pradesh', 'Uttarakhand', 'West Bengal'
    ];

    const StateDropdown = ({handleChange,value,imp}) => {
        
    return (
        <div className="state-dropdown">
        <label htmlFor="states" 
        className="block mb-2 text-sm font-medium text-gray-700">State {imp&&<span className='text-red-600'>*</span>}</label>
        <select id="states" 
        name="states" 
        value={value}
        onChange={handleChange}
        className="bg-gray-50 
        border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark
                                :focus:border-blue-500">
            <option value="">-- Select a State --</option>
            {statesInIndia.map((state, index) => (
            <option key={index} value={state}>{state}</option>
            ))}
        </select>
        </div>
    );
    };

    export default StateDropdown;
